export default {
  common: {
    off: '关闭',
    strong: '强',
    short: '短',
    long: '长',
    leftButton: '左键',
    rightButton: '右键',
    leftValue: '左：{value}',
    rightValue: '右：{value}',
  },
  tabs: {
    triggerTravel: '按键触发行程',
    rapidTrigger: '按键RT行程',
    vibration: '点击触感与反馈',
    sound: '点击音效与音量',
    config: '按键配置',
    calibration: '按键校准',
  },
  sections: {
    triggerTravel: '按键触发行程',
    rapidTrigger: '按键RT行程',
    vibration: '振动反馈',
    sound: '音效与音量',
  },
  mode: {
    both: '左键 + 右键',
    left: '左键',
    right: '右键',
  },
  travel: {
    differentValues: '左右键行程点设置不同',
    setValue: '设置行程点 {value}',
  },
  rapidTrigger: {
    differentValues: '左右键RT行程设置不同',
    enable: '启用RT',
    setValue: '设置按键RT行程 {value}',
    riskTip: '较低的按键 RT 行程，可能会带来自动触发的风险',
  },
  vibration: {
    differentValues: '左右键振动强度设置不同',
    powerWarning: '更强的触觉反馈设置会导致功耗增加',
    typeGroup: '振动反馈类型',
    feedback: '触感',
    types: {
      mechanical: '类机械按键',
      optical: '类光按键',
      electromagnetic: '电磁按键',
    },
  },
  sound: {
    label: '音效',
    option: '音效{value}',
    setVolume: '设置音量 {value}{unit}',
  },
  volume: {
    label: '音量',
    option: '音量{value}{unit}',
  },
  restore: {
    title: '重置默认',
    content: '当前功能自定义设置，将重置出厂默认状态。此过程不可撤销，是否确认恢复？',
  },
  presets: {
    loginRequired: '需要登陆个人中心才可增加按键预设',
    createTitle: '增加按键预设',
    namePlaceholder: '请输入预设名称',
    defaultUserName: '自定义预设',
    untitled: '未命名预设',
    currentUnavailable: '当前按键参数尚未读取完成',
    maxReached: '最多只能上传 {count} 个按键预设',
    uploaded: '按键预设上传成功',
    uploadFailed: '按键预设上传失败',
    loadFailed: '获取个人按键预设失败',
    overwrite: '覆盖',
    overwriteTips: '将当前参数覆盖此预设',
    overwriteTitle: '覆盖按键预设',
    overwriteCloudConfirm: '确认将当前参数覆盖“{name}”吗？',
    overwritten: '按键预设覆盖成功',
    overwriteFailed: '按键预设覆盖失败',
    renameTitle: '重命名按键预设',
    renamed: '按键预设重命名成功',
    renameFailed: '按键预设重命名失败',
    deleteTitle: '删除按键预设',
    deleteConfirm: '确认删除“{name}”吗？删除后无法恢复。',
    deleted: '按键预设删除成功',
    deleteFailed: '按键预设删除失败',
    names: {
      official1: '官方预设1',
      official2: '官方预设2',
      official3: '官方预设3',
    },
    applyTitle: '应用{name}',
    applyPreset: '应用预设',
    overwriteConfirm: '应用后将覆盖当前预设的按键触发参数，是否继续？',
    applying: '应用中...',
    confirmApply: '确定应用',
    applied: '{name}已应用',
    applyFailed: '{name}应用失败，请重试',
  },
  calibration: {
    instructions: {
      hold: '长按鼠标左/右键，',
      success: '按键显示绿色即校准成功',
      simultaneous: '（支持同时按压），',
      save: '完成后点击【保存校准】。',
    },
    entering: '正在进入...',
    saving: '正在保存...',
    cancelling: '正在取消...',
    saveCalibration: '保存校准',
    cancelCalibration: '取消校准',
    startCalibration: '开始校准',
    passed: '校准通过',
    calibrating: '校准中',
    waiting: '待触发',
    notStarted: '未开始校准',
    saved: '校准数据已保存',
  },
  errors: {
    configNotSupported: '当前设备不支持 RT 配置',
    calibrationNotSupported: '当前设备不支持 RT 校准',
    enterCalibrationFailed: '进入校准模式失败',
    saveCalibrationFailed: '保存校准数据失败',
  },
}
